module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.84a37de.woff";